import styled from 'styled-components';
import {basicColor, device, padding} from '@/styles/template';



export const TestWrap = styled.div`
    color: ${basicColor.white};
  	background: ${props => props.theme.color.MidtoneItem};
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 8rem;
    padding-bottom: 12rem;
  
    @media ${device.tablet} {
        padding-top: 10rem;
    }
  }
`

export const TestTop = styled.div`
    position: absolute;
    z-index: 4;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`

export const ProgressCounter = styled.div`
    padding-left: 3rem;
    
    & span {
            color: ${basicColor.accent};
    }
`


export const TestInnerContainer = styled.section`
    width: 100%;
    max-width: 900px;
    margin: 0 auto;
    padding: 0 ${padding.normal};
`